import { Flex } from "@chakra-ui/layout";
import { useEffect, useState } from "react";
import Combobox from "react-widgets/Combobox";
import "react-widgets/styles.css";

type InputComponentEmailType = {
  email: string;
  setEmail: any;
};

export default function InputComponentEmail({ email, setEmail }: InputComponentEmailType) {
  const [openHelper, setOpenHelper] = useState<boolean>(false);
  const emailRegex = /@(.+)?/gim;

  function HandleKeyPress(e) {
    // console.log("entro aq", e);
    if (e?.key === "Enter") {
      setOpenHelper(false);
    }
  }

  useEffect(() => {
    if (email.includes(".com")) {
      setOpenHelper(false);
    } else if (email.indexOf("@") !== -1) {
      setOpenHelper(true);
    } else {
      setOpenHelper(false);
    }
  }, [email]);

  return (
    <Flex
      fontWeight={"500"}
      bgColor={"ll-gray.600"}
      fontSize={"text1"}
      border="1px solid"
      borderColor="ll-gray.100"
      borderRadius={"50px"}
      w={"full"}
    >
      <Combobox
        value={email}
        onChange={(e: any) => {
          setEmail(e);
          HandleKeyPress(e);
        }}
        // onClick={(e) => HandleKeyPress(e)}
        onClickCapture={(e) => HandleKeyPress(e)}
        onSelect={() => setOpenHelper(false)}
        containerClassName={"inputClass"}
        style={{ width: "100%" }}
        hideCaret
        open={openHelper}
        // open={email.indexOf("@") !== -1 ? true : false}
        data={
          email.indexOf("@") !== -1
            ? [
                email.replace(emailRegex, "") + "@gmail.com",
                email.replace(emailRegex, "") + "@googlemail.com",
                email.replace(emailRegex, "") + "@yahoo.com",
                email.replace(emailRegex, "") + "@hotmail.com",
                email.replace(emailRegex, "") + "@msn.com",
                email.replace(emailRegex, "") + "@pneufree.com.br"
              ]
            : []
        }
        placeholder="E-MAIL"
      />
    </Flex>
  );
}
